import React from "react";

const Home = (props) => {
    return <h1>Home Page</h1>
}

export default Home